import weixin from './weixin'
import auth from './auth'
export default {
  ...weixin,
  ...auth
}
